import { NormeEnum } from '../../../../models/enums/norme.enum';
import { FormsEnum } from '../../../../models/enums/forms.enum';

export class FormItem {
  public intitule: string;
  public typedavis: string;
  public directive: string;
  public enum: string;
  public description: string;
  public url: string;
  public norme: NormeEnum;

  constructor() {}
}
